import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
const SvgStateBlocked = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 16 16" role="img" ref={ref} {...props}><path fill="currentColor" d="M8 0a8 8 0 1 0 8 8 8 8 0 0 0-8-8zm4.191 4.682-6.613 7.44a.826.826 0 1 1-1.235-1.1l6.613-7.44a.826.826 0 0 1 1.235 1.1z" /></svg>;
const ForwardRef = forwardRef(SvgStateBlocked);
export default ForwardRef;